import angular from 'angular';
import '../shared.module';

function cpRequirePermission(SessionService) {
  return {
    restrict: 'A',
    priority: 590,
    link(scope, element, attrs) {
      if (SessionService.hasPermission(attrs.cpRequirePermission)) return;
      element.remove();
    }
  };
}

cpRequirePermission.$inject = ['SessionService'];

angular.module('app.shared').directive('cpRequirePermission', cpRequirePermission);
